import banner2 from "../assets/project1.jpeg";
import UnifiedServicePage from "./UnifiedServicePage";

export default function BoreholeProjectsPage() {
  return (
    <UnifiedServicePage
      title="Borehole Drilling & Geographical Survey Projects"
      kicker="Expert Water Infrastructure Services"
      intro="We provide professional borehole drilling, geographic and hydrogeological surveys, and sustainable water supply solutions for communities, government, and private clients."
      heroImage={banner2}
      overviewTitle="Reliable Groundwater Solutions"
      overviewText="From site investigation to long-term maintenance, our team delivers safe, data-driven borehole systems designed for durable water access."
      featureTitle="Core Services"
      features={[
        {
          title: "Deep Borehole Drilling",
          desc: "Drilling and installation of rural and urban water boreholes with dependable yield outcomes.",
        },
        {
          title: "Geophysical Surveys",
          desc: "Soil resistivity and subsurface mapping to guide foundations, pipelines, and utility planning.",
        },
        {
          title: "Hydrogeological Assessments",
          desc: "Groundwater availability and quality assessments for safe and reliable supply systems.",
        },
        {
          title: "Rehabilitation & Maintenance",
          desc: "Cleaning, upgrades, and repairs for existing non-functional or low-yield boreholes.",
        },
        {
          title: "Water Quality Testing",
          desc: "Testing and monitoring to ensure compliance with health and environmental standards.",
        },
        {
          title: "Solar Pump Integration",
          desc: "Solar-powered pumping and storage solutions for resilient, low-cost operations.",
        },
      ]}
      focusTitle="Selected Projects & Clients"
      focusItems={[
        {
          title: "Rural Water Supply",
          desc: "Village councils and local communities across Dodoma and Morogoro.",
        },
        {
          title: "Infrastructure Surveys",
          desc: "Survey support for authorities and private developers in transport and civil works.",
        },
        {
          title: "Community Water Programs",
          desc: "Hydrogeological support for NGO and community-driven water projects.",
        },
        {
          title: "Ongoing Service Contracts",
          desc: "Multi-region maintenance and monitoring for sustained borehole performance.",
        },
      ]}
      testimonyQuote="The team delivered professional borehole and survey services with excellent post-installation support."
      testimonyAuthor="Community Water Official"
      ctaTitle="Need a Borehole or Survey Project?"
      ctaText="Engage our team for technical assessment, drilling, installation, and long-term service support."
    />
  );
}
